import React from "react";
import { Row, Col } from 'react-bootstrap'

class Newsletter extends React.Component {
	
	render() {
             
		return (


        <div className="newsletter">
         <div className="container">
         <Row>
         <div className="newsletter__caption">
         
         <Col md={6}>
         <h3> Do not miss anything ! Subscribe </h3>
         <p> I would like to be informed about current trends, offers and 
vouchers by e-mail in the future. A deregistration is possible
at any time free of charge. </p>
         </Col>
         </div>
         <Col md={6}>
         <form id="register-newsletter">
                     <input type="text" name="newsletter" required="" placeholder="Enter your email address"/>
                        <input type="submit" className="btn btn-custom-3" value="SIGN UP"/>
         </form>
         </Col>


      </Row>
        </div>
        </div>

       );
    }
  }
  
  export default Newsletter;
  


// WEBPACK FOOTER //
// ./src/Components/Newsletter/Newsletter.jsx